import dynamic from 'next/dynamic';

import { NavLoader } from '../components/NavLoader';

const DefaultNavigation = dynamic(
  async () => {
    const { DefaultNavigation } = await import('@vimeo/default-navigation');
    return DefaultNavigation;
  },
  {
    loading: () => <NavLoader />,
    ssr: false,
  },
);

export const NavigationModule = () => (
  <DefaultNavigation isSideNavActive={false} hasThemeSupport={false} />
);
